import React from "react";
import DefaultLayout from "../layouts/default";
import { graphql } from "gatsby";
import { PageType } from "../types/Types";
import ContentBlocks from "../components/ContentBlocks";

export const PagesQuery = graphql`
  fragment pagesPagesFragment on CMS_pages_Entry {
    id
    title
    seoTitle
    overviewDescription
    seoDescription
    overviewButtonText
    overviewButtonLink
    uri
    url
    typeHandle
    backgroundColor
    backgroundColorCustom
    backgroundImage {
      id
      title
      url
      alt
    }
    overviewImage {
      id
      title
      url
      alt
      width
      height
    }
    localized {
      id
      url
      uri
      language
    }
  }

  fragment contentBlocksFragment on CMS_pages_Entry {
    contentBlocks {
      ... on CMS_contentBlockMenuCardBlock_Entry {
        ...contentBlockMenuCardBlockFragment
      }
      ... on CMS_contentBlockCatBlockRooms_Entry {
        ...contentBlockCatBlockRoomsFragment
      }
      ... on CMS_contentBlockCalendarBlock_Entry {
        ...contentBlockCalendarBlockFragment
      }
      ... on CMS_contentBlockCategoriesTeaserBlock_Entry {
        ...contentBlockCategoriesTeaserBlockFragment
      }
      ... on CMS_contentBlockTextBlock_Entry {
        ...contentBlockTextBlockFragment
      }
      ... on CMS_contentBlockTitleBlock_Entry {
        ...contentBlockTitleBlockFragment
      }
      ... on CMS_contentBlockTitleBlockSub_Entry {
        ...contentBlockTitleBlockSubFragment
      }
      ... on CMS_contentBlockImageBlock_Entry {
        ...contentBlockImageBlockFragment
      }
      ... on CMS_contentBlockTwoColumnsBlock_Entry {
        ...contentBlockTwoColumnsBlockFragment
      }
      ... on CMS_contentBlockNewsletterBlock_Entry {
        ...contentBlockNewsletterBlockFragment
      }
    }
  }

  fragment contentBlockMenuCardBlockFragment on CMS_contentBlockMenuCardBlock_Entry {
    id
    title
    typeHandle
    menuCardDescription
    menuCardZusatz
    menuCardMenu {
      id
      ... on CMS_menus_Entry {
        id
        title
        typeHandle
        menuEntry {
          ... on CMS_menuEntryTitleBlock_Entry {
            id
            typeHandle
            menuEntryTitle
          }
          ... on CMS_menuEntryBlock_Entry {
            id
            typeHandle
            anzahlPersonen
            menuEntryLabel
            menuEntryPrice
            menuEntryText
          }
          ... on CMS_menuEntryPageBreak_Entry {
            id
            typeHandle
            menuEntryPageBreak
          }
        }
      }
    }
  }

  fragment contentBlockCatBlockRoomsFragment on CMS_contentBlockCatBlockRooms_Entry {
    id
    title
    typeHandle
    overviewPages {
      ... on CMS_pages_Entry {
        ...pagesPagesFragment
      }
    }
  }

  fragment eventFragment on CMS_events_Entry {
    id
    title
    url
    typeHandle
    eventDateDoorsOpen
    eventdateEventBegin
    eventPerformer
    priceBookingInAdvance
    priceBoxOffice
    ticketlink
    overviewDescription
    eventDescription
    uri
    overviewImage {
      id
      title
      alt
      url
      width
      height
    }
  }

  fragment contentBlockCalendarBlockFragment on CMS_contentBlockCalendarBlock_Entry {
    id
    title
    typeHandle
    calendarDescription
    calendarEvents {
      id
      ... on CMS_events_Entry {
        ...eventFragment
      }
    }
  }

  fragment contentBlockCategoriesTeaserBlockFragment on CMS_contentBlockCategoriesTeaserBlock_Entry {
    id
    title
    typeHandle
    teaserBlockCategories {
      ... on CMS_pages_Entry {
        ...pagesPagesFragment
      }
    }
  }

  fragment contentBlockTextBlockFragment on CMS_contentBlockTextBlock_Entry {
    id
    title
    typeHandle
    textBlockText
  }

  fragment contentBlockTitleBlockFragment on CMS_contentBlockTitleBlock_Entry {
    id
    title
    typeHandle
    titleBlockTitle
  }

  fragment contentBlockTitleBlockSubFragment on CMS_contentBlockTitleBlockSub_Entry {
    id
    title
    typeHandle
    titleBlockTitleSub
  }

  fragment contentBlockImageBlockFragment on CMS_contentBlockImageBlock_Entry {
    id
    title
    typeHandle
    imageBlockImage {
      id
      title
      url
      alt
      height
      width
    }
  }

  fragment contentBlockTwoColumnsBlockFragment on CMS_contentBlockTwoColumnsBlock_Entry {
    id
    title
    typeHandle
    twoColumnsText
    twoColumnsImage {
      id
      title
      url
      alt
    }
    twoColumnsImgPos
  }

  fragment contentBlockNewsletterBlockFragment on CMS_contentBlockNewsletterBlock_Entry {
    id
    title
    typeHandle
    newsletterBlockText
  }

  query ($uri: String!, $siteId: CMS_QueryArgument) {
    cms {
      entry(uri: [$uri], siteId: [$siteId]) {
        id
        title
        url
        typeHandle
        siteId
        language
        uri
        ancestors {
          id
          title
          typeHandle
          uri
        }
        ... on CMS_pages_Entry {
          ...pagesPagesFragment
          ...contentBlocksFragment
        }
      }
    }
  }
`;

const Page: React.FC<PageType> = ({
  data: {
    cms: {
      entry: {
        id,
        title,
        seoTitle,
        url,
        overviewDescription,
        seoDescription,
        overviewImage,
        overviewButtonText,
        overviewButtonLink,
        typeHandle,
        siteId,
        language,
        uri,
        backgroundColor,
        backgroundColorCustom,
        backgroundImage,
        contentBlocks,
        localized,
      },
    },
  },
}) => {
  return (
    <DefaultLayout
      id={id}
      title={title}
      seoTitle={seoTitle}
      url={url}
      description={overviewDescription}
      seoDescription={seoDescription}
      image={overviewImage}
      typeHandle={typeHandle}
      siteId={siteId}
      language={language}
      backgroundColor={backgroundColor}
      backgroundColorCustom={backgroundColorCustom}
      backgroundImage={backgroundImage}
      localized={localized}
    >
      <ContentBlocks
        contentBlocks={contentBlocks}
        language={language}
        overviewButtonText={overviewButtonText}
        overviewButtonLink={overviewButtonLink}
      />
    </DefaultLayout>
  );
};

export default Page;
